import logo from './logo.svg';
import './App.css';
import GlobalServicesProvider from './services/GlobalServicesProvider';
import { AuthProvider } from './auth/JwtContext';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import Router from "./routes";
import { HelmetProvider } from "react-helmet-async";


export default function App() {
  return (
    <GlobalServicesProvider>
      <AuthProvider>
        <HelmetProvider>
          <BrowserRouter>
            <ScrollToTop />
            <MotionLazyContainer>
              <ThemeProvider>
                <Router />
              </ThemeProvider>
            </MotionLazyContainer>
          </BrowserRouter>
        </HelmetProvider>
      </AuthProvider>
    </GlobalServicesProvider>

  );
}
